//create function that parses filename from content-disposition header
export const getFilenameFromHeader = (header?: string | null): string => {
  //get filename from content-disposition header
  if (!header) return ''
  const filename = header
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith('filename='))
    ?.split('=')[1]
    .replace(/"/g, '')

  //return filename
  return filename || ''
}
